<template lang="pug">
  #graphtitle
    p(:class="lang")
      |{{locatedTitle}}
</template>
<script>
  import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState([
      'title',
      'lang',
    ]),
    locatedTitle: function(){
      if(/ja/.test(this.lang)){
        return this.title.ja;
      }else{
        return this.title.en;
      }
    },
  }
}
</script>
<style lang="sass">
  #graphtitle
    height: 100%
    background-color: #E5E5E5
    font-size: 1.8em
    line-height: 50px
    text-align: center
    position: relative
    z-index: 1000
    font-weight: bold
    &.en
      font-size: 2.1em
      font-weight: 400

</style>